import {
  globalMessageHandler,
  GridModalFormProps,
  useForm,
  Validator,
} from "common";
import I18n from "i18n-js";
import { getUserService, UserFormItem, UserOptions } from "./userApi";

export interface UseUserFormProps extends GridModalFormProps {}

export default function useUserForm({ id, afterSave }: UseUserFormProps) {
  const service = getUserService();

  const form = useForm<UserFormItem, UserOptions>({
    id,
    ignoreNavigateAfterCreate: true,
    translationCategory: "User",
    rules: {
      first_name: Validator.rule.any().required(),
      last_name: Validator.rule.any().required(),
      email: Validator.rule.any().required(),
      role: Validator.rule.any().required(),
      status: Validator.rule.any().required(),
    },
    afterChange: (newItem, id, option) => {
      if (newItem.permissions) {
        let newPermission: string[] = newItem.permissions;
        const allOptions = form.options.permissions;
        newItem.permissions.forEach((value: string, index: number) => {
          const match = value.match(/^(manage|view)(.+)$/);
          if (match && match[1] && match[2]) {
            const [type, permission] = [match[1], match[2]];
            if (type == "manage") {
              const otherPermissionValue = "view" + permission;

              let otherTypeFound = false;
              allOptions.forEach((option) => {
                if (option.value == otherPermissionValue) {
                  otherTypeFound = true;
                }
              });

              if (otherTypeFound && !newItem.permissions.includes(otherPermissionValue)) {
                newPermission.push(otherPermissionValue);
              }
            }
          }
        });

        form.setAttributes({
          permissions: newPermission,
        });
      }

    },
    afterSave,
    afterLoad: _newItem => {},
    onValidationFailed: () => {
      globalMessageHandler.error(I18n.t("App.formHasErrors"));
    },
    ...service,
  });

  return form;
}
